"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _button = _interopRequireDefault(require("./button"));

var _box = _interopRequireDefault(require("./box"));

var _flex = _interopRequireDefault(require("./flex"));

var _image = _interopRequireDefault(require("./image"));

var _input = _interopRequireDefault(require("./input"));

var _rawHtml = _interopRequireDefault(require("./raw-html"));

var _text = _interopRequireDefault(require("./text"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/**
 * Primitives are base level components that handle style related props. These are
 * the basis for all components in the library and allow higher level components to
 * be composed of a common set of functionality with predictable rules.
 * Primitives styles can be extended using styled-components. All primitive
 * components accept an "tag" prop which will dictate the underlying element.
 * Primitives components all automatically remove style related props from being
 * passed any further down the component tree.
 */
var Primitives = {
  Box: _box["default"],
  Button: _button["default"],
  Flex: _flex["default"],
  Image: _image["default"],
  Input: _input["default"],
  RawHtml: _rawHtml["default"],
  Text: _text["default"]
};
var _default = Primitives;
exports["default"] = _default;